import type { NextPage } from "next";
import { SectionsPage } from "../features/SectionsPage";

const Sections: NextPage = () => {
  return <SectionsPage />;
};

export default Sections;
